import { Inject, Injectable } from '@angular/core';

import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { Observable, of } from 'rxjs';

import { BuildABet } from '../../../../../../../lib/tokens-base/token-base.models';
import { IBetslipMessages } from '../../../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../../../base/services/betslip-messages-provider.service';
import { BetAndGetToken, CriteriaType } from '../../../../../reward-tokens/reward-tokens.model';
import { BetslipError } from '../../../../errors/betslip-error';
import { RewardTokensBetBuilderError } from '../../../../errors/general/betandget/reward-tokens-bet-builder-error';
import { IExtendedMessage, MessageFormatter } from '../message-formatter';

@Injectable()
export class RewardTokensBetBuilderMessageFormatter extends MessageFormatter<RewardTokensBetBuilderError> {
    private messages: IBetslipMessages;
    constructor(
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) private messageProvider: IBetslipMessagesProviderService,
        private stringInterpolationPipe: StringInterpolationPipe,
    ) {
        super();
        this.messages = messageProvider.getMessages();
    }

    format(error: RewardTokensBetBuilderError): Observable<string | IExtendedMessage> {
        const betAndGetToken = error.token as BetAndGetToken;
        const betBuilderText = this.messageProvider.getMessages().crmTokens.errors.BetBuilderText;
        let errorMsg = this.stringInterpolationPipe.transform(this.messages.crmTokens.errors.CriteriaNotMet, {
            criteria: betBuilderText || CriteriaType.BetBuilder.toString(),
        });
        if (betAndGetToken.buildABet === BuildABet.No) {
            errorMsg = this.messages.errors.EdsBetAndGetError;
        }

        return of(errorMsg);
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof RewardTokensBetBuilderError;
    }
}
